import { action, thunk, persist, thunkOn } from 'easy-peasy';
import callApi, { generateUrlParams } from '../helpers/ApiAction';

const state = {
  clients: {
    list: [],
    pagination: {
      per_page: 10,
      current_page: 1,
      last_page: 1,
      total: 0
    },
    loading: false,
  },
  loading: [],
  building: []
};

const selectors = {
  clientsList: state.clients.list
};

const actions = {
  setLoadingClients: action((state, payload) => {
    state.clients.loading = payload;
  }),
  fetchClients: thunk(async (actions, payload) => {
    actions.setLoadingClients(true);
    const res = await callApi({
      endpoint: `clients${generateUrlParams(payload)}`,
      method: 'GET'
    });

    const json = await res.json();

    actions.setClientList(json);
  }),
  onFetchedClients: thunkOn(
    actions => [actions.fetchClients],
    (actions) => {
      actions.setLoadingClients(false);
    }
  ),
  buildAll: thunk(async () => {
    await callApi({
      endpoint: 'clients/build-all',
      method: 'POST',
    });
  }),
  fetchClient: thunk(async (actions, payload) => {
    actions.setLoadingClient({ uuid: payload, loading: true });

    const res = await callApi({
      endpoint: `clients/${payload}`,
      method: 'GET'
    });

    const json = await res.json();

    actions.updateClient(json);
  }),
  triggerClientSetup: thunk(async (actions, payload) => {
    actions.setLoadingClient({ uuid: payload, loading: true });

    const res = await callApi({
      endpoint: `clients/${payload}/setup`,
      method: 'POST'
    });

    const json = await res.json();

    actions.updateClient(json);
  }),
  onFetchedClient: thunkOn(
    actions => [actions.fetchClient, actions.triggerClientSetup],
    (actions, { payload }) => {
      actions.setLoadingClient({ uuid: payload, loading: false });
    }
  ),
  createClient: thunk(async (actions, payload) => {
    const res = await callApi({
      endpoint: 'clients',
      method: 'POST',
      type: 'formdata',
      body: payload
    });

    const json = await res.json();

    // TODO: Add store action for adding a single client to store.
    console.log(json);
  }),
  promote: thunk(async (actions, payload) => {
    const res = await callApi({
      endpoint: `clients/${payload.uuid}/promote`,
      method: 'PUT',
    });

    const json = await res.json();

    actions.updateClient(json);
  }),
  startBuild: thunk(async (actions, payload) => {
    actions.setLoadingBuild({ uuid: payload, loading: true });

    const res = await callApi({
      endpoint: `clients/${payload.uuid}/build`,
      method: 'POST',
      body: {
        ...payload,
      },
      callbacks: payload.callbacks
    })
    return await res.json();
  }),
  onFinishBuilding: thunkOn(
    actions => actions.startBuild,
    (actions, { payload }) => {
      actions.setLoadingBuild({ uuid: payload, loading: false });
    }
  ),
  editClient: thunk(async (actions, payload) => {
    const res = await callApi({
      endpoint: `clients/${payload.get('uuid')}`,
      method: 'POST',
      type: 'formdata',
      body: payload
    });

    const json = await res.json();

    actions.updateClient(json);
  }),
  setLoadingBuild: action((state, payload) => {
    if (payload.loading) {
      state.building.push(payload.uuid);
    } else {
      state.building = state.building.filter(uuid => uuid !== payload.uuid);
    }
  }),
  setLoadingClient: action((state, payload) => {
    if (payload.loading) {
      state.loading.push(payload.uuid);
    } else {
      state.loading = state.loading.filter(uuid => uuid !== payload.uuid);
    }
  }),
  updateClient: action((state, payload) => {
    const {
      data: { client }
    } = payload;

    const clientIndex = state.clients.list.findIndex(
      ({ uuid }) => uuid === client.uuid
    );

    if (clientIndex !== -1) {
      state.clients.list[clientIndex] = client;
    } else {
      state.clients.list.push(client);
    }
  }),
  setClientList: action((state, payload) => {
    const {
      data: { clients },
      pagination
    } = payload;

    const { current_page, per_page } = pagination;

    if (current_page === 1 || per_page === 0) {
      state.clients.list = clients;
    } else {
      state.clients.list.push(...clients);
    }

    state.clients.pagination = pagination;
  }),
};

export default persist(
  {
    ...state,
    ...selectors,
    ...actions
  },
  { blacklist: ['loading', 'building'] }
);
